import * as config from 'config';
import { apiFetch, getAuthorizationHeaders } from 'utils/fetch';
import {
  SoftwareFileUpload,
  SoftwareFilter,
  SoftwareUploadAttributes,
  SoftwaresResponse,
  Software,
  ReleaseSoftwareRequest,
  UpdateSoftwareRequest,
} from 'models/software';

export async function findSoftwares(
  offset: number,
  limit: number,
  filter: SoftwareFilter[]
): Promise<SoftwaresResponse> {
  let filterString = '';
  filter.forEach(
    (f) =>
      (filterString = filterString.concat(`&filter[${f.attribute}]=${f.value}`))
  );
  const url = `${config.backendApi}/softwares?offset=${offset}&limit=${limit}${filterString}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers });
}
export async function getFileUploadUrl(): Promise<SoftwareFileUpload> {
  const url = `${config.backendApi}/softwares/fileUploadUrl`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers, method: 'POST' });
}

export async function uploadFileToS3Bucket(
  uploadUrl: string,
  file: File
): Promise<SoftwareFileUpload> {
  const options = {
    method: 'PUT',
    body: file,
  };
  return apiFetch(uploadUrl, options);
}
export async function uploadSoftware(
  software: SoftwareUploadAttributes
): Promise<Software> {
  const url = `${config.backendApi}/softwares/upload`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'software',
        attributes: { ...software },
      },
    }),
    headers,
  };

  return apiFetch(url, options);
}
export async function getSoftwareById(
  id: string,
  includePreSignedUrl: boolean = false
): Promise<Software> {
  const url = includePreSignedUrl
    ? `${config.backendApi}/softwares/${id}?include=preSignedUrl`
    : `${config.backendApi}/softwares/${id}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers, method: 'GET' });
}
export async function releaseSoftware(
  releaseSoftwareRequest: ReleaseSoftwareRequest
): Promise<void> {
  const url = `${config.backendApi}/softwares/${releaseSoftwareRequest.data.id}/release`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'POST',
    body: JSON.stringify(releaseSoftwareRequest),
    headers,
  };

  return apiFetch(url, options);
}

export async function updateSoftware(
  updateSoftwareRequest: UpdateSoftwareRequest
): Promise<void> {
  const url = `${config.backendApi}/softwares/${updateSoftwareRequest.data.id}`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'PATCH',
    body: JSON.stringify(updateSoftwareRequest),
    headers,
  };

  return apiFetch(url, options);
}
